var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    { staticClass: "communities-card", attrs: { href: _vm.link } },
    [
      _c("div", { staticClass: "communities-card__image" }, [
        _vm.imageUrl
          ? _c("img", { attrs: { src: _vm.imageUrl, alt: _vm.imageAlt } })
          : _vm._e(),
        _vm._v(" "),
        _vm.title
          ? _c("h2", {
              staticClass: "communities-card__title",
              domProps: { innerHTML: _vm._s(_vm.title) },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "communities-card__info" },
        [
          _vm.location || _vm.homeStyle
            ? _c("h6", [
                _vm.homeStyle
                  ? _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.homeStyle) },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.location && _vm.homeStyle
                  ? _c("span", [_vm._v(" | ")])
                  : _vm._e(),
                _vm._v("\n        " + _vm._s(_vm.location) + "\n        "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm._l(_vm.categories, function (category, key) {
            return _c("p", { key: key }, [_vm._v(_vm._s(category.name))])
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }